import { Link } from "react-router-dom";
import Footer from "@/components/site/Footer";
import BookingSidebar from "@/components/site/BookingSidebar";
import angkorSunrise from "@/assets/visite-angkor-wat-cambodge.jpg";


const schedule = [
  { time: "4:15 – 4:35 AM", title: "Hotel Pickup", body: "Your comfortable, air-conditioned vehicle collects you from your hotel. An early start, but absolutely worth it." },
  { time: "5:30 AM", title: "Enter Angkor Wat in the Dark", body: "Begin through the quieter eastern entrance, away from the main crowds. Walk ancient corridors illuminated by your flashlight, surrounded by intricate bas-relief carvings." },
  { time: "6:00 AM", title: "Sunrise at Angkor Wat", body: "Take your position by one of the reflecting pools as the sun rises behind the temple's iconic towers an unforgettable moment, and a perfect photo opportunity." },
  { time: "6:30 – 8:30 AM", title: "Explore Angkor Wat", body: "Discover the inner galleries, chambers and upper terraces. Your guide brings the carvings and history of the Khmer Empire to life with fascinating stories and insights." },
  { time: "9:00 AM", title: "Optional Breakfast Break", body: "Enjoy a short rest and breakfast (optional, not included)." },
  { time: "9:30 AM", title: "Visit Ta Prohm", body: "Explore the famous 'Tomb Raider temple', where giant tree roots intertwine with ancient ruins one of the most photogenic sites in the Angkor complex." },
  { time: "10:30 AM", title: "Angkor Thom", body: "Enter the ancient city, passing the Terrace of the Elephants and the Terrace of the Leper King." },
  { time: "11:00 AM", title: "Bayon Temple", body: "Discover the iconic smiling stone faces of Bayon over 200 massive carvings that continue to intrigue visitors and historians alike." },
  { time: "11:30 AM", title: "South Gate of Angkor Thom", body: "Walk past rows of stone gods and demons lining the causeway an impressive and symbolic entrance to the ancient city." },
  { time: "12:30 – 1:30 PM", title: "Return to Hotel", body: "Head back to your hotel with unforgettable memories and a camera full of stunning photos." },
];

const TourAngkorWatSunrise = () => {
  return (
    <main className="bg-background">
      {/* HERO */}
      <header className="relative bg-jungle text-background overflow-hidden">
        <img
          src={angkorSunrise}
          alt="Private Angkor Wat sunrise tour with French-speaking guide reflected in the lotus pool, Siem Reap Cambodia"
          width={1920}
          height={1280}
          className="absolute inset-0 h-full w-full object-cover opacity-60"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-jungle/70 via-jungle/50 to-jungle/95" />
        <div className="relative z-10">
          <div className="container flex items-center justify-between py-6">
            <Link to="/" className="flex items-center gap-2">
              <span className="font-display text-2xl tracking-wide">Aṅkor</span>
              <span className="text-[10px] uppercase tracking-[0.3em] opacity-70 hidden sm:inline">Sojourns</span>
            </Link>
            <Link to="/tours" className="text-[11px] uppercase tracking-[0.3em] border-b border-background/40 pb-1 hover:border-primary hover:text-primary transition-colors">
              ← All Tours
            </Link>
          </div>
          <div className="container pt-20 pb-32 md:pt-28 md:pb-44 max-w-5xl">
            <p className="text-xs uppercase tracking-[0.4em] text-primary mb-6">— One Day Sojourn</p>
            <h1 className="font-display text-5xl md:text-7xl leading-[0.95] text-balance lg:text-2xl">
              One Day Tours <em className="font-light">to</em> Angkor Wat.
            </h1>
            <p className="mt-10 max-w-xl text-background/70 leading-relaxed text-xl font-light">
              The perfect sunrise. No crowds. No guesswork just the photos you came for, led by an expert guide who knows every hidden path.
            </p>
            <div className="mt-10 flex flex-wrap gap-x-10 gap-y-3 text-[11px] uppercase tracking-[0.3em] text-background/80">
              <span>Duration · 8 Hours</span>
              <span>Group · 2–15</span>
              <span>From $35</span>
            </div>
          </div>
        </div>
      </header>

      {/* INTRO */}
      <section className="py-24 md:py-32">
        <div className="container max-w-4xl">
          <p className="text-xs uppercase tracking-[0.4em] text-primary mb-6">— Why Sunrise</p>
          <h2 className="font-display text-4xl md:text-5xl leading-[1.05] mb-10 text-balance">
            Skip the crowds. Capture incredible photos. Experience Angkor Wat at its most magical.
          </h2>
          <div className="space-y-6 text-lg font-light text-muted-foreground leading-relaxed">
            <p>
              Most visitors arrive around 9:00 AM, when the site is already crowded and the light is harsh. Our Angkor Wat Sunrise Tour gets you there early around 4:15 AM  so you can enjoy peaceful surroundings, soft morning light, and truly unforgettable views.
            </p>
            <p>
              This tour includes expert guiding, visits to four major temples Angkor Wat, Ta Prohm, Bayon Temple, and Angkor Thom as well as comfortable transportation with hotel pickup. You'll return with stunning photos and a deeper understanding of Cambodia's most iconic heritage site.
            </p>
          </div>

        </div>
      </section>


      {/* TIMELINE */}
      <section className="pb-24 md:pb-32">
        <div className="container max-w-6xl"><div className="grid lg:grid-cols-[1fr_420px] gap-x-12 gap-y-12 items-start"><div>
          <p className="text-xs uppercase tracking-[0.4em] text-primary mb-6">— Your Sunrise Adventure</p>
          <h2 className="font-display text-4xl md:text-5xl leading-[1.05] mb-16 text-balance">
            What you will do, hour by hour.
          </h2>
          <ol className="relative border-l border-border pl-8 md:pl-10 space-y-12">
            {schedule.map((s) => (
              <li key={s.time} className="relative">
                <span className="absolute -left-[41px] md:-left-[49px] top-1 h-3 w-3 rounded-full bg-primary ring-4 ring-background" />
                <p className="text-[11px] uppercase tracking-[0.3em] text-primary mb-2">{s.time}</p>
                <h3 className="font-display text-2xl md:text-3xl mb-3">{s.title}</h3>
                <p className="text-muted-foreground font-light leading-relaxed text-lg">{s.body}</p>
              </li>
            ))}
          </ol>
        </div><BookingSidebar pricePerPerson={135} tourTitle="One Day Tour to Angkor Wat" pricingTiers={[{ maxPax: 2, price: 135 }, { maxPax: 6, price: 145 }, { maxPax: 10, price: 168 }]} /></div></div>
      </section>

      {/* INCLUDED / NOT INCLUDED */}
      <section className="bg-secondary py-24 md:py-32">
        <div className="container max-w-5xl grid md:grid-cols-2 gap-x-12 gap-y-12">
          <div>
            <p className="text-xs uppercase tracking-[0.4em] text-primary mb-6">— What's Included</p>
            <ul className="space-y-4 font-light text-lg">
              <li className="border-b border-border pb-4">Air-conditioned transport with hotel pickup &amp; drop-off</li>
              <li className="border-b border-border pb-4">Expert English-speaking guide</li>
              <li className="border-b border-border pb-4">Complimentary bottled water</li>
              <li className="border-b border-border pb-4">Refreshing cold towels</li>
              <li className="pb-4">Photography guidance for the best angles &amp; lighting</li>
            </ul>
          </div>
          <div>
            <p className="text-xs uppercase tracking-[0.4em] text-primary mb-6">— Not Included</p>
            <ul className="space-y-4 font-light text-lg">
              <li className="border-b border-border pb-4">Meals</li>
              <li className="border-b border-border pb-4">Temple entrance fee US $37 (valid for all temples, one day)</li>
              <li className="pb-4">Personal expenses &amp; gratuities</li>
            </ul>
            <p className="mt-6 text-sm text-muted-foreground font-light">
              The Angkor Pass can be purchased online via the official Angkor Pass website.
            </p>
          </div>
        </div>
      </section>

      {/* WHAT TO BRING */}
      <section className="py-24 md:py-32">
        <div className="container max-w-5xl">
          <p className="text-xs uppercase tracking-[0.4em] text-primary mb-6">— Essential Items</p>
          <h2 className="font-display text-4xl md:text-5xl leading-[1.05] mb-16 text-balance">What to bring, what to leave behind.</h2>
          <div className="grid md:grid-cols-3 gap-x-10 gap-y-12">
            <div>
              <h3 className="font-display text-2xl mb-5">Required</h3>
              <ul className="space-y-3 font-light text-muted-foreground">
                <li>Flashlight or phone light</li>
                <li>Temple pass (US $37)</li>
                <li>Modest clothing shoulders &amp; knees covered</li>
                <li>Comfortable walking shoes</li>
              </ul>
            </div>
            <div>
              <h3 className="font-display text-2xl mb-5">Recommended</h3>
              <ul className="space-y-3 font-light text-muted-foreground">
                <li>Camera with extra batteries</li>
                <li>Small backpack</li>
                <li>Cash for breakfast</li>
                <li>Sun protection hat, sunscreen</li>
              </ul>
            </div>
            <div>
              <h3 className="font-display text-2xl mb-5">Leave at Hotel</h3>
              <ul className="space-y-3 font-light text-muted-foreground">
                <li>Passport (bring a copy)</li>
                <li>Airline tickets</li>
                <li>Excess cash</li>
                <li>Valuable jewellery</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* GOOD TO KNOW */}
      <section className="bg-secondary py-24 md:py-32">
        <div className="container max-w-4xl">
          <p className="text-xs uppercase tracking-[0.4em] text-primary mb-6">— Good to Know</p>
          <div className="space-y-6 text-lg font-light text-muted-foreground leading-relaxed">
            <p>
              Sunrise tours are the most popular and tend to sell out quickly, especially during the dry season (November to March). We recommend booking at least 48 hours in advance during peak season, even earlier.
            </p>
            <p>
              <span className="text-foreground">Weather.</span> Hot and dry weather is expected throughout this tour. There is always the possibility of a shower or two, but it is likely to be dry most of the time. Most of the woodland sites we visit have low humidity.
            </p>
            <p>
              <span className="text-foreground">Food.</span> Khmer cuisine is similar to most Southeast Asian cooking, but rather less spicy. Good bread is available in many areas thanks to the French influence, and there is a surprisingly wide range of local brews to try.
            </p>
            <p>
              <span className="text-foreground">Please note.</span> This tour is not wheelchair accessible. Children under 8 years old are not permitted. Maximum group size is 2–15 travellers in an air-conditioned vehicle.
            </p>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-24 md:py-32">
        <div className="container max-w-3xl text-center">
          <p className="text-xs uppercase tracking-[0.4em] text-primary mb-6">— Reserve Your Sunrise</p>
          <h2 className="font-display text-4xl md:text-6xl leading-[1.05] mb-10 text-balance">
            Begin your journey before the world wakes.
          </h2>
          <Link
            to="/#contact"
            className="inline-block bg-foreground text-background px-10 py-4 text-[11px] uppercase tracking-[0.3em] hover:bg-primary transition-colors"
          >
            Book Now →
          </Link>
        </div>
      </section>
      <Footer />
    </main>
  );
};

export default TourAngkorWatSunrise;
